import Campaign from '@/classes/Campaign.js'
import Run from '@/classes/Run.js'

export default class AdvertFactory{
    getAdvert(advert_type){
        if(advert_type == 'campaigns' || advert_type == 'Campaigns' || advert_type == 'campaign' || advert_type == 'Campaign') return new Campaign()
        else if(advert_type == 'runs' || advert_type == 'Runs' || advert_type == 'run' || advert_type == 'Run') return new Run()
        else return new Campaign()
    }
}